class Product {
    constructor(properties) {
        this.price = properties.price;
        this.priceRaw = properties.priceRaw;
        this.sku = properties.sku || '';
        this.dimensions = properties.dimensions || '';
        this.url = properties.url || '';
        this.priceRrp = properties.priceRrp || '';
        this.ean = properties.ean || '';
        this.freeShipping = properties.freeShipping || false;
        this.isNewProduct = properties.isNewProduct || false;
        this.showFreeFitting = properties.showFreeFitting || false;
        this.fittingPromotion = properties.fittingPromotion || null;
        this.shippingTime = properties.shippingTime || '';
        this.shippingData = properties.shippingData || [];
        this.shippingDataHasValue = properties.shippingDataHasValue || false;
        this.stock = properties.stock || 0;
        this.customerAverageRatings = properties.customerAverageRatings ? { ...properties.customerAverageRatings } : null;
        this.reviews = {
            reviewCount: properties.reviews ? properties.reviews.reviewCount : 0,
            average: properties.reviews ? properties.reviews.average : 0
        };
        this.hasImage = !!properties.hasImage || false;
        this.productImage = properties.productImage || '';
        this.noImageUrl = properties.noImageUrl || '';
        this.manufacturer = properties.manufacturer || '';
        this.manufacturerImage = properties.manufacturerImage || '';
        this.model = properties.model || '';
        this.profileText = properties.profileText || '';
        this.brand = properties.brand || '';
        this.hideManufacturerLogo = properties.hideManufacturerLogo || false;
        this.buy4for3 = typeof properties.buy4for3 !== 'undefined' ? properties.buy4for3 : false;
        this.clearance = typeof properties.clearance !== 'undefined' ? properties.clearance : false;
        this.instantCash = typeof properties.instantCash !== 'undefined' ? properties.instantCash : false;
        this.tyroolasChoice = typeof properties.tyroolasChoice !== 'undefined' ? properties.tyroolasChoice : false;
        this.badges = properties.badge || [];
        this.productBadges = properties.productBadges || [];
        this.mostPopularVehicle = properties.mostPopularVehicle || null;
        this.badges = this.badges && this.badges.map((badge) => {
            badge.badgeName = null;
            badge.text = badge.text || null;
            badge.color = badge.color || null;
            return badge;
        });
        this.off15 = false;
        this.bestseller = typeof properties.lowestPriceGuarantee !== 'undefined' ? properties.lowestPriceGuarantee : false;
        this.newProduct = typeof properties.newProduct !== 'undefined' ? properties.newProduct : false;
        this.savePercent = typeof properties.savePercent !== 'undefined' ? properties.savePercent : false;
        this.availableQuantities = properties.availableQuantities || [];
        this.buyerAssistUrl = Object.prototype.hasOwnProperty.call(properties, 'buyerAssistUrl')
            ? properties.buyerAssistUrl : null;
        this.priceDiscount = properties.priceDiscount || null;
        this.labelFuelEfficiency = properties.labelFuelEfficiency || null;
        this.labelWetGrip = properties.labelWetGrip || null;
        this.labelNoise = properties.labelNoise || null;
    }
}

export default Product;
